export const USERNAME_INVALID = 'Username must be a valid e-mail';
export const USERNAME_REQUIRED = 'Username is required';
export const PASSWORD_REQUIRED = 'Password is required';
export const PASSWORD_MIN_LENGTH = 'Password should have at least 8 characters';
export const PASSWORD_MAX_LENGTH = 'Password should have at most 50 characters';
export const PASSWORD_LOWERCASE =
	'Password must contain at least 1 lowercase letter';
export const PASSWORD_UPPERCASE =
	'Password must contain at least 1 uppercase letter';
export const PASSWORD_NUMBER = 'Password must contain at least 1 number';
export const PASSWORD_SPECIAL = 'Password must contain at least 1 symbol';
export const CODE_REQUIRED = 'Code is required';
export const CODE_MIN_LENGTH = 'Code should have at least 6 characters';
export const CODE_TYPE = 'Code should only contain numbers';
export const RECAPTCHA_REQUIRED = 'Complete the captcha to continue';
